export default (axios, baseURL) => async () => {
  const url = `/v2/users/user-info-cache`;
  const axiosConfig = {
    method: 'DELETE',
    baseURL,
    url,
    skipAuthLogout: true
  };
  try {
    const axiosResponse = await axios(axiosConfig);
    return axiosResponse.data;
  } catch (apiErr) {
    throw new Error('Failed to delete user cache');
  }
};
